module.exports = __webpack_public_path__ + "img/scatter.01191a64.png";